import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';

function ProductSEO({
  lang,
  meta,
  metaTitle,
  twitterTitle,
  metaDescription,
  metaKeywords,
  canonicalLink,
}) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const { articleModifiedTime, lastModefied } = data.site.siteMetadata;
        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            title={metaTitle}
            meta={[
              {
                name: `description`,
                content: `${metaDescription}`,
              },
              {
                name: `keywords`,
                content: `${metaKeywords}`,
              },
              {
                property: `twitter:description`,
                content: `${metaDescription}`,
              },
              {
                property: `twitter:title`,
                content: twitterTitle || metaTitle,
              },
              {
                property: `twitter:card`,
                content: `summary_large_image`,
              },
              {
                name: `twitter:site`,
                content: `@mashvisor`,
              },
              {
                name: `twitter:creator`,
                content: `@mashvisor`,
              },
              {
                name: `twitter:image:src`,
                content: `https://www.mashvisor.com/application/files/thumbnails/file_social_media/4114/7083/0800/bg-screen-3.jpg`,
              },
              {
                name: `twitter:image`,
                content: `https://www.mashvisor.com/application/files/thumbnails/file_social_media/4114/7083/0800/bg-screen-3.jpg`,
              },
              //google meta data
              {
                property: `og:description`,
                content: `${metaDescription}`,
              },
              {
                property: `og:site_name`,
                content: `Mashvisor`,
              },
              {
                property: `og:image`,
                content: `https://www.mashvisor.com/application/files/thumbnails/file_social_media/4114/7083/0800/bg-screen-3.jpg`,
              },
              {
                name: `og:title`,
                content: `${metaTitle}`,
              },
              {
                name: `og:type`,
                content: `article`,
              },
              {
                name: `og:locale`,
                content: `en_US`,
              },
              {
                name: `article:modified_time`,
                content: articleModifiedTime,
              },
              {
                name: `article:section`,
                content: `Blog`,
              },
              {
                name: `fb:app_id`,
                content: `627405640696073`,
              },
              {
                'http-equiv': `last-modified`,
                content: lastModefied,
              },
            ].concat(meta)}
          >
            <link rel="canonical" href={canonicalLink.replace(/\/$/, '')} />
          </Helmet>
        );
      }}
    />
  );
}

ProductSEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
};

ProductSEO.propTypes = {
  lang: PropTypes.string,
  meta: PropTypes.array,
};

export default ProductSEO;

const detailsQuery = graphql`
  query DefaultProductsSEOQuery {
    site {
      siteMetadata {
        articleModifiedTime
        lastModefied
      }
    }
  }
`;
